import { Container, Row, Col, Button } from 'reactstrap';
import { callNativeMobileApp, useTranslator } from '@front-activerse/common-components';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '@front-activerse/common-components';
import { withMobileAppMode } from '@front-activerse/common-components';

const NoDiet = ({ mobileAppMode }) => {
  const { t } = useTranslator();
  const navigate = useNavigate();

  const {
    images: { noDietImg },
    consts: { FIRST_DIET_SETTINGS_STEP_SLUG },
  } = useAppContext();

  const handleClick = (event) => {
    event.preventDefault();
    if (mobileAppMode) {
      callNativeMobileApp({
        action: 'open_modal',
        payload: {
          path: `/diet-settings/all/${FIRST_DIET_SETTINGS_STEP_SLUG}`,
          modal_variant: 'always_close_btn',
        },
      });
    } else {
      navigate(`/diet-settings/all/${FIRST_DIET_SETTINGS_STEP_SLUG}`);
    }
  };

  return (
    <div className="no-diet">
      <section className="text-center d-flex align-items-center full-height">
        <Container>
          <Row>
            <Col md={{ size: 4, offset: 4 }}>
              <img srcSet={`${noDietImg} 100w`} sizes="50px" className="img-fluid mb-xl" alt="" />
              <p className="mb-xl text-text-variant-color">
                {t('shoppingList.errorScreen.content')}
              </p>

              <Button color="primary" onClick={handleClick} className="w-100">
                {t('shoppingList.errorScreen.button')}
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default withMobileAppMode(NoDiet);
